import { Gender } from '@/shared/types/generated';

export const GENDER_OPTIONS: { value: Gender; label: string }[] = [
  { value: Gender.Female, label: 'Female' },
  { value: Gender.Male, label: 'Male' },
  { value: Gender.NonBinary, label: 'Non-binary' },
  { value: Gender.PreferNotToSay, label: 'Prefer not to say' },
];

export function getGenderLabel(gender?: Gender | null): string {
  const match = GENDER_OPTIONS.find((opt) => opt.value === gender);
  return match?.label ?? '';
}
